if (!customElements.get("media-grid-slide")) {
	const waitForSplide = () => new Promise(resolve => {
			if (typeof Splide < "u") resolve();
			else {
				const checkSplide = setInterval(() => {
					typeof Splide < "u" && (clearInterval(checkSplide), resolve())
				}, 100)
			}
		}),
		SplideSlide = (element, properties) => {
			if (typeof Splide > "u") throw new Error("Splide is not loaded yet.");
			return new Splide(element, properties).mount()
		};
	class MediaGridSlides extends HTMLElement {
		constructor() {
			super(), this.section = this.closest("section"), this.mainSlides = this.querySelectorAll("[data-main-slide]"), this.sliderInstances = [], this.prevButton = this.querySelector("[data-prev-slide]"), this.nextButton = this.querySelector("[data-next-slide]"), this.#init(), this.#setupEventListeners()
		}
		async #init() {
			await waitForSplide();
			try {
				this.mainSlides.forEach(slide => {
					const options = JSON.parse(slide.dataset.splide);
					this.sliderInstances.push(SplideSlide(slide, options))
				})
			} catch (error) {
				console.error("Failed to initialize Splide sliders:", error)
			}
		}
		#setupEventListeners() {
			this.prevButton && this.prevButton.addEventListener("click", () => this.#navigate("prev", "moving-reverse")), this.nextButton && this.nextButton.addEventListener("click", () => this.#navigate("next", "moving-forward")), this.#hoverHandler(), this.#spotlightHandler(), Shopify.designMode && (this.addEventListener("shopify:block:select", e => console.log(e)), this.addEventListener("shopify:block:deselect", e => console.log(e)))
		}
		#navigate(direction, className) {
			this.#changeScheme(direction), this.mainSlides.forEach(slide => {
				slide.classList.remove("moving-forward", "moving-reverse"), slide.classList.add(className)
			}), this.sliderInstances.forEach(slider => {
				slider.go(direction === "next" ? ">" : "<"), slider.Components.Elements.slides.forEach(slide => {
					slide.classList.remove("slide-active")
				});
				const index = slider.index,
					currentSlide = slider.Components.Slides.getAt(index)?.slide;
				currentSlide && currentSlide.classList.add("slide-active")
			})
		}
		#changeScheme(direction) {
			const schemeElement = this.section.querySelector("[data-slide-scheme]");
			if (!schemeElement) return;
			const schemes = JSON.parse(schemeElement.dataset.slideScheme),
				currentScheme = this.#getCurrentScheme(schemeElement);
			let currentIndex = schemes.indexOf(currentScheme);
			currentIndex = direction === "next" ? (currentIndex + 1) % schemes.length : (currentIndex - 1 + schemes.length) % schemes.length, this.#updateSchemeClass(schemeElement, schemes[currentIndex])
		}
		#getCurrentScheme(element) {
			return Array.from(element.classList).find(cls => cls.startsWith("scheme-")) || null
		}
		#updateSchemeClass(element, newScheme) {
			const currentScheme = this.#getCurrentScheme(element);
			currentScheme && element.classList.remove(currentScheme), element.classList.add(newScheme)
		}
		#hoverHandler() {
			!this.prevButton || !this.nextButton || document.addEventListener("mousemove", e => {
				const mouseX = e.clientX,
					windowWidth = window.innerWidth,
					threshold = windowWidth * .2;
				this.prevButton.classList.toggle("show", mouseX < threshold), this.nextButton.classList.toggle("show", mouseX > windowWidth - threshold)
			})
		}
		#spotlightHandler() {
			const spotlight = this.section.querySelector("[data-spotlight]");
			if (!spotlight) return;
			const smoothness = .3;
			let spotlightX = 0,
				spotlightY = 0;
			this.section.addEventListener("mousemove", e => {
				const rect = this.section.getBoundingClientRect(),
					mouseX = e.clientX - rect.left - spotlight.offsetWidth / 2,
					mouseY = e.clientY - rect.top - spotlight.offsetHeight / 2;
				spotlightX += (mouseX - spotlightX) * smoothness, spotlightY += (mouseY - spotlightY) * smoothness, spotlight.style.transform = `translate3d(${spotlightX}px, ${spotlightY}px, 0)`
			}), this.section.addEventListener("mouseout", () => {
				spotlight.style.transform = "translate3d(0, 0, 0)"
			})
		}
	}
	customElements.define("media-grid-slide", MediaGridSlides)
}
//# sourceMappingURL=/cdn/shop/t/8/assets/media-grid-slide.js.map?v=87012505244948687781749447818